// extracted by mini-css-extract-plugin
module.exports = {"a-search-bar":"SearchBar_a-search-bar__2FCsZ","a-search-bar__input":"SearchBar_a-search-bar__input__3u9CY","a-search-bar__icon":"SearchBar_a-search-bar__icon__10mkI"};